"use strict";

exports.__esModule = true;
exports.default = hardSet;


/*
  hardSet: 
    - hard set incoming state
*/

function hardSet(inboundState) {
  return inboundState;
}